/* eslint-disable */
import React from 'react';
const TrendIndicator = ({
    value,
    changeText,
    isIncrease,
    showArrow
}) => {
    const arrowSymbol = isIncrease ? '↑' : '↓';
    const changeColor = isIncrease ? 'green' : 'red';

    return (
        <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
            fontFamily: 'sans-serif',
            fontWeight: 'bold',
        }}>
            <div className='d-flex  mt-5' style={{
                // display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
            }}>
                <div style={{ fontSize: '35px', display: 'flex', justifyContent: 'center' }}>
                    
                        {value}{' '}
                        {showArrow && (
                            <span style={{ color: changeColor, }}>
                                {arrowSymbol}
                            </span>
                        )}
                </div>
                <span style={{ fontSize: '15px', color: changeColor }}>
                    {changeText}
                </span>
            </div>
        </div>
    );
};

export default TrendIndicator;